import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { FiAlertOctagon, FiDatabase, FiXCircle } from 'react-icons/fi'

import api from '../../../utils/api'
import useMyPermission from '../../../hooks/useMyPermission'
import './BackupOverdueModal.css'

function daysSince(dateStr) {
    if (!dateStr) return null
    const diffMs = Date.now() - new Date(dateStr).getTime()
    return Math.floor(diffMs / (1000 * 60 * 60 * 24))
}

// Avisa quem pode gerar backup (backup_Create) quando o último backup passou de 7 dias
// (ou nunca foi gerado). Aparece uma vez por carregamento do app, não a cada navegação.
function BackupOverdueModal() {

    const [open, setOpen] = useState(false)
    const [days, setDays] = useState(null)
    const navigate = useNavigate()
    const { checkPermission } = useMyPermission()

    useEffect(() => {
        const token = localStorage.getItem('token') || ''
        if (!token) return

        api.get('/backup/getLast', {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => {
            if (!response) return
            const canCreateBackup = checkPermission(response.data.permission, 'backup_Create')
            if (!canCreateBackup) return

            const d = daysSince(response.data.backup?.date)
            if (d === null || d > 7) {
                setDays(d)
                setOpen(true)
            }
        }).catch(() => {})
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (!open) return null

    return (
        <div className="bom-overlay" onClick={() => setOpen(false)}>
            <div className="bom-box" onClick={(e) => e.stopPropagation()}>

                <button type="button" className="bom-close shd-modal-close" onClick={() => setOpen(false)}>X</button>

                <div className="bom-icon"><FiAlertOctagon size={22} /></div>
                <p className="bom-title">Backup do sistema atrasado</p>
                <p className="bom-message">
                    {days === null
                        ? 'Nenhum backup foi gerado ainda.'
                        : `O último backup foi gerado há ${days} dias.`}
                    {' '}Gere um novo backup para manter os dados protegidos.
                </p>

                <div className="bom-actions">
                    <button
                        type="button"
                        className="bom-btn bom-btn-primary"
                        onClick={() => { setOpen(false); navigate('/backup') }}
                    >
                        <FiDatabase size={18} />
                        <span>Fazer backup agora</span>
                    </button>
                    <button type="button" className="bom-btn bom-btn-cancel" onClick={() => setOpen(false)}>
                        <FiXCircle size={20} />
                        <span>Agora não</span>
                    </button>
                </div>

            </div>
        </div>
    )
}

export default BackupOverdueModal
